import { IVerifyPasswordRequestTyype } from "./type"

const accountSettingBaseUrl = "/employee"

export const VerifyPasswordUrl = (params: IVerifyPasswordRequestTyype) => {
    return `${accountSettingBaseUrl}/verify/${params.passcode}`
}